import { addMonths } from 'date-fns';

export const processDocuments = (data, global = false) => data.filter((i) => i.content && i.content.trim().length)
	.filter((i) => i.target === 'all' || (global && i.target === 'global') || (i.target === 'position' && !global))
	.map((i) => ({ ...i, validUntil: i.monthsValid ? addMonths(new Date(), i.monthsValid) : null, monthsValid: undefined }));
